﻿import { CategoricalIndicatorPalette, CategoricalIndicatorPaletteWithValues, GDFPalletCode } from '@fe/weather';

function CategoricalIndicator({
    data,
    showLabels
}: {
    data: CategoricalIndicatorPalette | CategoricalIndicatorPaletteWithValues;
    showLabels?: boolean;
}) {
    const { name, entries } = data;
    showLabels ??= true;
    const svgWidth = showLabels ? 180 : 30;
    const isIcon = !entries.some((entry) => !entry.icon);
    const rectSize = (isIcon ? 22 : 15) * (data?.scale || 1.0);
    const gap = isIcon ? 0 : 5;

    const svgHeight = (rectSize + gap) * entries.filter((x) => !x.hide).length;
    return (
        <div className="legend-entry">
            <div style={{ fontSize: 12 }}>
                {name}
                {/*todo remove false*/}
                {import.meta.env.DEV && showLabels && (
                    <span>
                        {' '}
                        (0x{data.id.toString(16)} {GDFPalletCode[data.id]})
                    </span>
                )}
            </div>
            <svg width={svgWidth} height={svgHeight} style={{ display: 'block' }}>
                {entries
                    .filter((x) => !x.hide)
                    .map((entry, index) => (
                        <g
                            key={index}
                            transform={`translate(0, ${index * (rectSize + gap)})`}
                            data-subtext={entry.subtext}
                            className={entry.subtext ? 'tooltip-target' : ''}>
                            {entry.icon ? (
                                <svg
                                    x="0"
                                    y="0"
                                    width={rectSize}
                                    height={rectSize}
                                    viewBox={entry.icon.viewBox}
                                    fill={entry.color || 'var(--text-color)'}
                                    dangerouslySetInnerHTML={{ __html: entry.icon.content }}
                                />
                            ) : (
                                <rect x="0" y="0" width={rectSize} height={rectSize} fill={entry.color} />
                            )}
                            {showLabels && (
                                <text
                                    x={rectSize + 5}
                                    y={rectSize / 2 + 2}
                                    fontSize="10"
                                    alignmentBaseline="middle"
                                    fill={'var(--text-color)'}>
                                    {entry.label}
                                </text>
                            )}
                        </g>
                    ))}
            </svg>
        </div>
    );
}

export default CategoricalIndicator;
